import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

const Homepage = () => {
    const navigate = useNavigate();

    return (
        <div className="page-general-container">
            <div className='page-general-background-color'></div>
    
            <div className='page-general-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
                <div className='page-general-background-image' style={{ backgroundImage: `url(https://res.cloudinary.com/dc1felxem/image/upload/v1741078754/hydros90_22124_Sustainable_residential_building_with_eco-frie_3ee8dc47-d37f-4df4-96e4-9dafa1286851_3_qlfno0.jpg)` }}></div>
            </div>
            <div className='page-main-content'>

                <div className="homepage-content">
                    <img src="/icon/compte-goutte-white-logo.png" alt="Changement climatique" className="homepage-image" />
                    <p className="homepage-description">
                    L’atelier Compte-Gouttes Immobilier & BTP est une version adaptée de l’atelier Compte-Gouttes, spécialement conçue pour les acteurs de l’immobilier, de la construction et des travaux publics. 
                    </p>
                    <p className="homepage-description">
                    Il vise à sensibiliser les professionnels aux enjeux de l’eau dans le secteur, en leur fournissant des clés de compréhension et des leviers d’action concrets.
                    </p>
                </div>

                <button className="start-button" onClick={() => navigate('/game_config/gameconfigjs')}>
                    Commencer l'Atelier
                </button>
            </div>
        </div>
    );
};

export default Homepage;
